import React from 'react'

export default function ChatBotIcon(props) {


    return (
        <>

            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><g stroke="#292d32" strokeLinecap="round" strokeLinejoin="round"><path d="m8.5 19h-.5c-4 0-6-1-6-6v-5c0-4 2-6 6-6h8c4 0 6 2 6 6v5c0 4-2 6-6 6h-.5c-.31 0-.61.15-.8.4l-1.5 2c-.66.88-1.74.88-2.4 0l-1.5-2c-.16-.22-.53-.4-.8-.4z" strokeMiterlimit="10" strokeWidth="1.5" /><g strokeWidth="2"><path d="m15.9965 11h.0089" /><path d="m11.9955 11h.009" /><path d="m7.99451 11h.00898" /></g></g></svg>

        </>
    )
}
